import { render, staticRenderFns } from "./certificateChoose.vue?vue&type=template&id=63d84aca&"
import script from "./certificateChoose.vue?vue&type=script&lang=js&"
export * from "./certificateChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports